var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm.showModalErroVersao
        ? _c("app-modal-erro-versao", {
            on: {
              closeModal: function() {
                return (_vm.showModalErroVersao = false)
              }
            }
          })
        : _vm._e(),
      _c("h1", { staticClass: "titulo" }, [_vm._v("Enviar Cadastro")]),
      _c(
        "el-row",
        {
          staticClass: "row-bg",
          attrs: { type: "flex", justify: "space-between" }
        },
        [
          _c(
            "el-col",
            { staticClass: "col-texto", attrs: { md: 12, lg: 12 } },
            [
              _c("div", [
                _c("h3", { staticClass: "titulo" }, [
                  _vm._v("Instruções para envio do cadastro")
                ]),
                _c("p", [
                  _c("b", [_vm._v("1. ")]),
                  _vm._v(
                    "Após concluído o cadastro no " +
                      _vm._s(_vm.SISTEMA) +
                      " Módulo Banco de Dados,\nexporte este cadastro para seu computador. Este arquivo exportado possui a extensão  "
                  ),
                  _c("span", { staticClass: "verde" }, [_vm._v(".sicarf")]),
                  _vm._v(".")
                ]),
                _c("p", [
                  _c("b", [_vm._v("2. ")]),
                  _vm._v(
                    "Para importação, clique no ícone de nuvem e selecione o arquivo."
                  )
                ]),
                _c("p", [
                  _c("b", [_vm._v("3. ")]),
                  _vm._v(
                    "Após o envio, será gerado um comprovante com um número de protocolo.\nGuarde este documento com segurança em seu computador ou realize a impressão."
                  )
                ]),
                _c("p", [
                  _c("b", [_vm._v("4. ")]),
                  _vm._v(
                    "O protocolo poderá ser solicitado posteriormente para acompanhamento do processo junto " +
                      _vm._s(_vm.isRondonia ? "à" : "ao") +
                      " " +
                      _vm._s(_vm.ORGAO) +
                      "\nnão sendo possível emitir segunda via do mesmo."
                  )
                ]),
                _c("p", [
                  _c("b", [_vm._v("5. ")]),
                  _vm._v(
                    "Pronto! Versões de cadastros suportadas: " +
                      _vm._s(_vm.versao)
                  )
                ])
              ])
            ]
          ),
          _c(
            "el-col",
            { staticClass: "col-upload", attrs: { md: 12, lg: 12 } },
            [
              _c("app-upload-tus-cadastro", {
                on: {
                  uploadSuccess: _vm.success,
                  uploadFail: _vm.fail,
                  selectedFile: _vm.setShowDownloadComprovante
                }
              })
            ],
            1
          )
        ],
        1
      ),
      _c("div", { staticClass: "container-video" }, [
        _vm.VIDEOS_TUTORIAIS
          ? _c("iframe", {
              staticClass: "default-iframe",
              attrs: {
                showinfo: "0",
                width: "50%",
                height: "350",
                rel: "0",
                src: _vm.VIDEOS_TUTORIAIS.COMO_ENVIAR,
                frameborder: "0",
                allow:
                  "accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture",
                allowfullscreen: "allowfullscreen",
                modestbranding: "1"
              }
            })
          : _vm._e()
      ]),
      _vm.showDownloadComprovante
        ? _c(
            "el-row",
            {
              staticClass: "row-bg",
              attrs: { type: "flex", justify: "space-between" }
            },
            [
              _c("el-col", { attrs: { md: 24, lg: 24 } }, [
                _c(
                  "div",
                  { staticClass: "download-comprovante" },
                  [
                    this.protocolo !== "PROCESSAMENTO"
                      ? _c(
                          "el-button",
                          {
                            attrs: {
                              type: "primary",
                              icon: "fas fa-cloud-download-alt"
                            },
                            on: {
                              click: function($event) {
                                return _vm.gerarComprovante()
                              }
                            }
                          },
                          [_vm._v("  Realizar Download do Comprovante")]
                        )
                      : _c(
                          "el-button",
                          {
                            attrs: {
                              type: "primary",
                              icon: "fas fa-cloud-download-alt"
                            },
                            on: {
                              click: function($event) {
                                return _vm.estouCiente()
                              }
                            }
                          },
                          [_vm._v("  Estou ciente")]
                        )
                  ],
                  1
                )
              ])
            ],
            1
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-6ff1605b", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6ff1605b","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/AppUploadCadastro.vue
// module id = null
// module chunks = 